import { useSelector, useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { claimDailyReward, clearError, getStreakInfo } from '../store/dailyRewardsSlice';

export const useDailyRewards = () => {
  const dispatch = useDispatch();
  const dailyRewards = useSelector(state => state.dailyRewards);

  console.log('🔄 [useDailyRewards] Current state:', dailyRewards);

  const claimReward = useCallback(() => {
    console.log('🔄 [useDailyRewards] claimReward called');
    console.log('📡 [useDailyRewards] Dispatching claimDailyReward thunk...');
    return dispatch(claimDailyReward());
  }, [dispatch]);

  const clearDailyRewardsError = useCallback(() => {
    console.log('🔄 [useDailyRewards] clearError called');
    dispatch(clearError());
  }, [dispatch]);

  const loadStreakInfo = useCallback(() => {
    console.log('🔄 [useDailyRewards] loadStreakInfo called');
    return dispatch(getStreakInfo());
  }, [dispatch]);

  // Получить конфигурацию для текущего дня из данных бэкенда
  const getCurrentDayConfig = useCallback(() => {
    // Используем данные с бэкенда, а не статическую конфигурацию
    const config = {
      coins: dailyRewards.rewards.coinsReward,
      tickets: dailyRewards.rewards.ticketsReward
    };
    console.log('📊 [useDailyRewards] getCurrentDayConfig from backend:', { 
      currentStreak: dailyRewards.currentStreak, 
      config 
    });
    return config;
  }, [dailyRewards.currentStreak, dailyRewards.rewards]);

  const getDayConfig = useCallback((day) => {
    const config = dailyRewards.streakConfig.find(config => config.day === day) || 
                   dailyRewards.streakConfig[6]; // fallback to day 7
    console.log('📊 [useDailyRewards] getDayConfig:', { day, config });
    return config;
  }, [dailyRewards.streakConfig]);

  return {
    ...dailyRewards,
    claimReward,
    clearError: clearDailyRewardsError,
    loadStreakInfo,
    getCurrentDayConfig,
    getDayConfig
  };
};